import { Component, OnInit, ViewContainerRef, OnDestroy, ViewChild } from '@angular/core';
import { TdDataTableService, TdDataTableSortingOrder, ITdDataTableSortChangeEvent, ITdDataTableColumn, TdDialogService, TdLoadingService, TdSearchBoxComponent } from '@covalent/core';
import { IPageChangeEvent } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';

import { User } from '../../../shared/classes/user';
import { UserService } from '../user.service';
import { SettingsService } from '../../../shared/services/settings.service';
import { ExportService } from '../../../shared/services/export.service';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import {Utils} from '../../../shared/utils';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
  providers: [UserService]
})
export class UserListComponent implements OnInit {
  @ViewChild('searchBox') _searchBox: TdSearchBoxComponent;

  subscription: Subscription = new Subscription();
  data: User[];

  columns: ITdDataTableColumn[] = [
    { name: 'first_name', label: 'First Name' },
    { name: 'last_name', label: 'Last Name' },
    { name: 'right_level', label: 'Write Level' },
    { name: 'branch', label: 'Branch' }
  ];

  filteredData: any[] = [];
  filteredTotal: number;
  //searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  //pageSize: number = 50;
  sortBy: string;
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  selectedRows: any[] = [];

  constructor(private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private location: Location,
    private _userService: UserService,
    public _exportService: ExportService,
    public _authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.presetSearchBox();

    this.subscription = this.getUsers();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  presetSearchBox() {
    if (this._settingsService.getSearchTerm('user')) {
      this._searchBox.value = this._settingsService.getSearchTerm('user');
      this._searchBox.searchClicked();
    }
  }

  getUsers(): Subscription {
    this._loadingService.register('loading');
    console.log("Loading All Users");

    return this._userService
      .getAllUsers()
      .subscribe((users: User[]) => {
        this.data = users;
        this.filteredData = this.data;
        //this.selectedRows = this.filteredData;
        this.filter();
        this._loadingService.resolve('loading');
      });
  }

  deleteSelectedUsers() {
    this._dialogService.openConfirm(
      {
        title: 'Confirm deletion',
        message: 'Are you sure you want to delete the selected users?'
      }
    ).afterClosed().subscribe(
      result => {
        if (result) {
          this.selectedRows.forEach(
            row => {
              this._userService.deleteOneUser(row).subscribe(
                response => {
                  if (response['status'] == 'SUCCESS') {
                    this.data = this.data.filter(d => { return d.id != response['id'] });
                    this.filter();
                  }
                }
              );
            }
          );
        }
      }
    );
  }

  selectAll() {
    let selected = !this.allSelected();

    if (selected) {
      this.filteredData.forEach(
        item => {
          this.select(true, item);
        }
      );
    } else {
      this.selectedRows = [];
    }

  }

  select(selected: boolean, row) {
    console.log(selected);

    if (selected) {
      if (!this.selectedRows.some(item => { return item.id == row.id })) {
        this.selectedRows.push(row);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(item => { return item.id != row.id })
    }
  }

  allSelected() {
    // Are there as many selected as there are in the list?
    return this.filteredData.length == this.selectedRows.length;
  }

  rowSelected(row) {
    return this.selectedRows.some((selected) => { return selected.id == row.id });
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortOrder = sortEvent.order === TdDataTableSortingOrder.Ascending
      ? TdDataTableSortingOrder.Descending
      : TdDataTableSortingOrder.Ascending;
    this.sortBy = sortEvent.name;
    this.filter();
  }

  search(searchTerm: string): void {
    this._settingsService.setSearchTerm('user', searchTerm);
    //this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.data;
    let excludedColumns: string[] = this.columns
      .filter((column: ITdDataTableColumn) => {
        return ((column.filter === undefined && column.hidden === true) ||
          (column.filter !== undefined && column.filter === false));
      }).map((column: ITdDataTableColumn) => {
        return column.name;
      });
    newData = this._dataTableService.filterData(newData, this._settingsService.getSearchTerm('user'), true, excludedColumns);
    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    this.filteredData = newData;
  }

  goBack(): void {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/admin/user-list/user-list.component.ts